import { DetailedHTMLProps, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export interface ContentProps
  extends DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> {
  children: ReactNode;
}

export default function PageContent({ ...props }: ContentProps) {
  return (
    <main {...props} className={twMerge("fl-p-8", props.className)}>
      {props.children}
    </main>
  );
}
